import _toConsumableArray from "/codebuild/output/src3459753244/src/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/codebuild/output/src3459753244/src/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/codebuild/output/src3459753244/src/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3459753244/src/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["alignment", "allowedPlacements", "autoAlignment"],
    _excluded2 = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
    _excluded3 = ["strategy"],
    _excluded4 = ["mainAxis", "crossAxis", "limiter"],
    _excluded5 = ["apply"];
import _regeneratorRuntime from "/codebuild/output/src3459753244/src/www/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function t(t) {
  return t.split("-")[1];
}

function e(t) {
  return "y" === t ? "height" : "width";
}

function n(t) {
  return t.split("-")[0];
}

function o(t) {
  return ["top", "bottom"].includes(n(t)) ? "x" : "y";
}

function i(i, r, a) {
  var l = i.reference,
      s = i.floating;
  var c = l.x + l.width / 2 - s.width / 2,
      f = l.y + l.height / 2 - s.height / 2,
      u = o(r),
      m = e(u),
      g = l[m] / 2 - s[m] / 2,
      d = "x" === u;
  var p;

  switch (n(r)) {
    case "top":
      p = {
        x: c,
        y: l.y - s.height
      };
      break;

    case "bottom":
      p = {
        x: c,
        y: l.y + l.height
      };
      break;

    case "right":
      p = {
        x: l.x + l.width,
        y: f
      };
      break;

    case "left":
      p = {
        x: l.x - s.width,
        y: f
      };
      break;

    default:
      p = {
        x: l.x,
        y: l.y
      };
  }

  switch (t(r)) {
    case "start":
      p[u] -= g * (a && d ? -1 : 1);
      break;

    case "end":
      p[u] += g * (a && d ? -1 : 1);
  }

  return p;
}

var r = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e, n) {
    var _n$placement, o, _n$strategy, r, _n$middleware, a, l, s, c, f, _i, u, m, g, d, p, _n, _i2, _s$_n, _a, _h, _yield$_h, _y, _x4, _w, _v;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _n$placement = n.placement;
            o = _n$placement === void 0 ? "bottom" : _n$placement;
            _n$strategy = n.strategy;
            r = _n$strategy === void 0 ? "absolute" : _n$strategy;
            _n$middleware = n.middleware;
            a = _n$middleware === void 0 ? [] : _n$middleware;
            l = n.platform;
            s = a.filter(Boolean);
            _context.next = 10;
            return null == l.isRTL ? void 0 : l.isRTL(e);

          case 10:
            c = _context.sent;
            _context.next = 13;
            return l.getElementRects({
              reference: t,
              floating: e,
              strategy: r
            });

          case 13:
            f = _context.sent;
            _i = i(f, o, c);
            u = _i.x;
            m = _i.y;
            g = o;
            d = {};
            p = 0;
            _n = 0;

          case 21:
            if (!(_n < s.length)) {
              _context.next = 56;
              break;
            }

            _s$_n = s[_n];
            _a = _s$_n.name;
            _h = _s$_n.fn;
            _context.next = 27;
            return _h({
              x: u,
              y: m,
              initialPlacement: o,
              placement: g,
              strategy: r,
              middlewareData: d,
              rects: f,
              platform: l,
              elements: {
                reference: t,
                floating: e
              }
            });

          case 27:
            _yield$_h = _context.sent;
            _y = _yield$_h.x;
            _x4 = _yield$_h.y;
            _w = _yield$_h.data;
            _v = _yield$_h.reset;
            u = null != _y ? _y : u;
            m = null != _x4 ? _x4 : m;
            d = _objectSpread(_objectSpread({}, d), {}, _defineProperty({}, _a, _objectSpread(_objectSpread({}, d[_a]), _w)));
            _context.t0 = _v && p <= 50;

            if (!_context.t0) {
              _context.next = 53;
              break;
            }

            p++;
            _context.t1 = "object" == typeof _v;

            if (!_context.t1) {
              _context.next = 52;
              break;
            }

            _v.placement && (g = _v.placement);
            _context.t2 = _v.rects;

            if (!_context.t2) {
              _context.next = 51;
              break;
            }

            if (!(!0 === _v.rects)) {
              _context.next = 49;
              break;
            }

            _context.next = 46;
            return l.getElementRects({
              reference: t,
              floating: e,
              strategy: r
            });

          case 46:
            _context.t3 = _context.sent;
            _context.next = 50;
            break;

          case 49:
            _context.t3 = _v.rects;

          case 50:
            f = _context.t3;

          case 51:
            _i2 = i(f, g, c), u = _i2.x, m = _i2.y;

          case 52:
            _n = -1;

          case 53:
            _n++;
            _context.next = 21;
            break;

          case 56:
            return _context.abrupt("return", {
              x: u,
              y: m,
              placement: g,
              strategy: r,
              middlewareData: d
            });

          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function r(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function a(t) {
  return "number" != typeof t ? function (t) {
    return _objectSpread({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, t);
  }(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}

function l(t) {
  return _objectSpread(_objectSpread({}, t), {}, {
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}

function s(_x5, _x6) {
  return _s.apply(this, arguments);
}

function _s() {
  _s = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, e) {
    var n, o, i, r, s, c, f, _e10, _e10$boundary, u, _e10$rootBoundary, m, _e10$elementContext, g, _e10$altBoundary, d, _e10$padding, p, h, y, x, w, v, b, R;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            void 0 === e && (e = {});
            o = t.x;
            i = t.y;
            r = t.platform;
            s = t.rects;
            c = t.elements;
            f = t.strategy;
            _e10 = e;
            _e10$boundary = _e10.boundary;
            u = _e10$boundary === void 0 ? "clippingAncestors" : _e10$boundary;
            _e10$rootBoundary = _e10.rootBoundary;
            m = _e10$rootBoundary === void 0 ? "viewport" : _e10$rootBoundary;
            _e10$elementContext = _e10.elementContext;
            g = _e10$elementContext === void 0 ? "floating" : _e10$elementContext;
            _e10$altBoundary = _e10.altBoundary;
            d = _e10$altBoundary === void 0 ? !1 : _e10$altBoundary;
            _e10$padding = _e10.padding;
            p = _e10$padding === void 0 ? 0 : _e10$padding;
            h = a(p);
            y = c[d ? "floating" === g ? "reference" : "floating" : g];
            _context11.t0 = l;
            _context11.t1 = r;
            _context11.next = 24;
            return null == r.isElement ? void 0 : r.isElement(y);

          case 24:
            _context11.t3 = n = _context11.sent;
            _context11.t2 = null == _context11.t3;

            if (_context11.t2) {
              _context11.next = 28;
              break;
            }

            _context11.t2 = n;

          case 28:
            if (!_context11.t2) {
              _context11.next = 32;
              break;
            }

            _context11.t4 = y;
            _context11.next = 38;
            break;

          case 32:
            _context11.t5 = y.contextElement;

            if (_context11.t5) {
              _context11.next = 37;
              break;
            }

            _context11.next = 36;
            return null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating);

          case 36:
            _context11.t5 = _context11.sent;

          case 37:
            _context11.t4 = _context11.t5;

          case 38:
            _context11.t6 = _context11.t4;
            _context11.t7 = u;
            _context11.t8 = m;
            _context11.t9 = f;
            _context11.t10 = {
              element: _context11.t6,
              boundary: _context11.t7,
              rootBoundary: _context11.t8,
              strategy: _context11.t9
            };
            _context11.next = 45;
            return _context11.t1.getClippingRect.call(_context11.t1, _context11.t10);

          case 45:
            _context11.t11 = _context11.sent;
            x = (0, _context11.t0)(_context11.t11);
            w = "floating" === g ? _objectSpread(_objectSpread({}, s.floating), {}, {
              x: o,
              y: i
            }) : s.reference;
            _context11.next = 50;
            return null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating);

          case 50:
            v = _context11.sent;
            _context11.next = 53;
            return null == r.isElement ? void 0 : r.isElement(v);

          case 53:
            _context11.t13 = _context11.sent;

            if (!_context11.t13) {
              _context11.next = 58;
              break;
            }

            _context11.next = 57;
            return null == r.getScale ? void 0 : r.getScale(v);

          case 57:
            _context11.t13 = _context11.sent;

          case 58:
            _context11.t12 = _context11.t13;

            if (_context11.t12) {
              _context11.next = 61;
              break;
            }

            _context11.t12 = {
              x: 1,
              y: 1
            };

          case 61:
            b = _context11.t12;
            _context11.t14 = l;

            if (!r.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context11.next = 69;
              break;
            }

            _context11.next = 66;
            return r.convertOffsetParentRelativeRectToViewportRelativeRect({
              rect: w,
              offsetParent: v,
              strategy: f
            });

          case 66:
            _context11.t15 = _context11.sent;
            _context11.next = 70;
            break;

          case 69:
            _context11.t15 = w;

          case 70:
            _context11.t16 = _context11.t15;
            R = (0, _context11.t14)(_context11.t16);
            return _context11.abrupt("return", {
              top: (x.top - R.top + h.top) / b.y,
              bottom: (R.bottom - x.bottom + h.bottom) / b.y,
              left: (x.left - R.left + h.left) / b.x,
              right: (R.right - x.right + h.right) / b.x
            });

          case 73:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _s.apply(this, arguments);
}

var c = Math.min,
    f = Math.max;

function u(t, e, n) {
  return f(t, c(e, n));
}

var m = function m(n) {
  return {
    name: "arrow",
    options: n,
    fn: function fn(i) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _data, _ref3;

        var _ref2, r, _ref2$padding, l, s, c, f, m, g, d, p, h, y, x, w, v, b, R, A, P, T, O, D, E, L, k;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref2 = n || {}, r = _ref2.element, _ref2$padding = _ref2.padding, l = _ref2$padding === void 0 ? 0 : _ref2$padding, s = i.x, c = i.y, f = i.placement, m = i.rects, g = i.platform;

                if (!(null == r)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", {});

              case 3:
                d = a(l);
                p = {
                  x: s,
                  y: c
                };
                h = o(f);
                y = e(h);
                _context2.next = 9;
                return g.getDimensions(r);

              case 9:
                x = _context2.sent;
                w = "y" === h ? "top" : "left";
                v = "y" === h ? "bottom" : "right";
                b = m.reference[y] + m.reference[h] - p[h] - m.floating[y];
                R = p[h] - m.reference[h];
                _context2.next = 16;
                return null == g.getOffsetParent ? void 0 : g.getOffsetParent(r);

              case 16:
                A = _context2.sent;
                P = A ? "y" === h ? A.clientHeight || 0 : A.clientWidth || 0 : 0;
                0 === P && (P = m.floating[y]);
                T = b / 2 - R / 2, O = d[w], D = P - x[y] - d[v], E = P / 2 - x[y] / 2 + T, L = u(O, E, D), k = null != t(f) && E != L && m.reference[y] / 2 - (E < O ? d[w] : d[v]) - x[y] / 2 < 0;
                return _context2.abrupt("return", (_ref3 = {}, _defineProperty(_ref3, h, p[h] - (k ? E < O ? O - E : D - E : 0)), _defineProperty(_ref3, "data", (_data = {}, _defineProperty(_data, h, L), _defineProperty(_data, "centerOffset", E - L), _data)), _ref3));

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
},
    g = ["top", "right", "bottom", "left"],
    d = g.reduce(function (t, e) {
  return t.concat(e, e + "-start", e + "-end");
}, []),
    p = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function h(t) {
  return t.replace(/left|right|bottom|top/g, function (t) {
    return p[t];
  });
}

function y(n, i, r) {
  void 0 === r && (r = !1);
  var a = t(n),
      l = o(n),
      s = e(l);
  var c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
  return i.reference[s] > i.floating[s] && (c = h(c)), {
    main: c,
    cross: h(c)
  };
}

var x = {
  start: "end",
  end: "start"
};

function w(t) {
  return t.replace(/start|end/g, function (t) {
    return x[t];
  });
}

var v = function v(e) {
  return void 0 === e && (e = {}), {
    name: "autoPlacement",
    options: e,
    fn: function fn(o) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var i, r, a, l, c, f, u, m, _e, g, _e$allowedPlacements, p, _e$autoAlignment, h, x, v, b, R, A, _y2, P, T, O, D, E, L, k, B;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                l = o.rects;
                c = o.middlewareData;
                f = o.placement;
                u = o.platform;
                m = o.elements;
                _e = e;
                g = _e.alignment;
                _e$allowedPlacements = _e.allowedPlacements;
                p = _e$allowedPlacements === void 0 ? d : _e$allowedPlacements;
                _e$autoAlignment = _e.autoAlignment;
                h = _e$autoAlignment === void 0 ? !0 : _e$autoAlignment;
                x = _objectWithoutProperties(_e, _excluded);
                v = void 0 !== g || p === d ? function (e, o, i) {
                  return (e ? [].concat(_toConsumableArray(i.filter(function (n) {
                    return t(n) === e;
                  })), _toConsumableArray(i.filter(function (n) {
                    return t(n) !== e;
                  }))) : i.filter(function (t) {
                    return n(t) === t;
                  })).filter(function (n) {
                    return !e || t(n) === e || !!o && w(n) !== n;
                  });
                }(g || null, h, p) : p;
                _context3.next = 15;
                return s(o, x);

              case 15:
                b = _context3.sent;
                R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0;
                A = v[R];

                if (!(null == A)) {
                  _context3.next = 20;
                  break;
                }

                return _context3.abrupt("return", {});

              case 20:
                _context3.t0 = y;
                _context3.t1 = A;
                _context3.t2 = l;
                _context3.next = 25;
                return null == u.isRTL ? void 0 : u.isRTL(m.floating);

              case 25:
                _context3.t3 = _context3.sent;
                _y2 = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3);
                P = _y2.main;
                T = _y2.cross;

                if (!(f !== A)) {
                  _context3.next = 31;
                  break;
                }

                return _context3.abrupt("return", {
                  reset: {
                    placement: v[0]
                  }
                });

              case 31:
                O = [b[n(A)], b[P], b[T]], D = [].concat(_toConsumableArray((null == (r = c.autoPlacement) ? void 0 : r.overflows) || []), [{
                  placement: A,
                  overflows: O
                }]), E = v[R + 1];

                if (!E) {
                  _context3.next = 34;
                  break;
                }

                return _context3.abrupt("return", {
                  data: {
                    index: R + 1,
                    overflows: D
                  },
                  reset: {
                    placement: E
                  }
                });

              case 34:
                L = D.slice().sort(function (t, e) {
                  return t.overflows[0] - e.overflows[0];
                }), k = null == (a = L.find(function (t) {
                  var e = t.overflows;
                  return e.every(function (t) {
                    return t <= 0;
                  });
                })) ? void 0 : a.placement, B = k || L[0].placement;
                return _context3.abrupt("return", B !== f ? {
                  data: {
                    index: R + 1,
                    overflows: D
                  },
                  reset: {
                    placement: B
                  }
                } : {});

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
};

var b = function b(e) {
  return void 0 === e && (e = {}), {
    name: "flip",
    options: e,
    fn: function fn(o) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var i, r, a, l, c, f, u, _e2, _e2$mainAxis, m, _e2$crossAxis, g, d, _e2$fallbackStrategy, p, _e2$fallbackAxisSideD, x, _e2$flipAlignment, v, b, R, A, P, T, O, D, E, L, _y3, _t, _e3, k, _t2, _e4, _n2, B, _t3;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                r = o.placement;
                a = o.middlewareData;
                l = o.rects;
                c = o.initialPlacement;
                f = o.platform;
                u = o.elements;
                _e2 = e;
                _e2$mainAxis = _e2.mainAxis;
                m = _e2$mainAxis === void 0 ? !0 : _e2$mainAxis;
                _e2$crossAxis = _e2.crossAxis;
                g = _e2$crossAxis === void 0 ? !0 : _e2$crossAxis;
                d = _e2.fallbackPlacements;
                _e2$fallbackStrategy = _e2.fallbackStrategy;
                p = _e2$fallbackStrategy === void 0 ? "bestFit" : _e2$fallbackStrategy;
                _e2$fallbackAxisSideD = _e2.fallbackAxisSideDirection;
                x = _e2$fallbackAxisSideD === void 0 ? "none" : _e2$fallbackAxisSideD;
                _e2$flipAlignment = _e2.flipAlignment;
                v = _e2$flipAlignment === void 0 ? !0 : _e2$flipAlignment;
                b = _objectWithoutProperties(_e2, _excluded2);
                R = n(r);
                A = n(c) === c;
                _context4.next = 23;
                return null == f.isRTL ? void 0 : f.isRTL(u.floating);

              case 23:
                P = _context4.sent;
                T = d || (A || !v ? [h(c)] : function (t) {
                  var e = h(t);
                  return [w(t), e, w(e)];
                }(c));
                d || "none" === x || T.push.apply(T, _toConsumableArray(function (e, o, i, r) {
                  var a = t(e);

                  var l = function (t, e, n) {
                    var o = ["left", "right"],
                        i = ["right", "left"],
                        r = ["top", "bottom"],
                        a = ["bottom", "top"];

                    switch (t) {
                      case "top":
                      case "bottom":
                        return n ? e ? i : o : e ? o : i;

                      case "left":
                      case "right":
                        return e ? r : a;

                      default:
                        return [];
                    }
                  }(n(e), "start" === i, r);

                  return a && (l = l.map(function (t) {
                    return t + "-" + a;
                  }), o && (l = l.concat(l.map(w)))), l;
                }(c, v, x, P)));
                O = [c].concat(_toConsumableArray(T));
                _context4.next = 29;
                return s(o, b);

              case 29:
                D = _context4.sent;
                E = [];
                L = (null == (i = a.flip) ? void 0 : i.overflows) || [];

                if (m && E.push(D[R]), g) {
                  _y3 = y(r, l, P), _t = _y3.main, _e3 = _y3.cross;
                  E.push(D[_t], D[_e3]);
                }

                if (!(L = [].concat(_toConsumableArray(L), [{
                  placement: r,
                  overflows: E
                }]), !E.every(function (t) {
                  return t <= 0;
                }))) {
                  _context4.next = 47;
                  break;
                }

                _t2 = ((null == (k = a.flip) ? void 0 : k.index) || 0) + 1, _e4 = O[_t2];

                if (!_e4) {
                  _context4.next = 37;
                  break;
                }

                return _context4.abrupt("return", {
                  data: {
                    index: _t2,
                    overflows: L
                  },
                  reset: {
                    placement: _e4
                  }
                });

              case 37:
                _n2 = "bottom";
                _context4.t0 = p;
                _context4.next = _context4.t0 === "bestFit" ? 41 : _context4.t0 === "initialPlacement" ? 44 : 45;
                break;

              case 41:
                _t3 = null == (B = L.map(function (t) {
                  return [t, t.overflows.filter(function (t) {
                    return t > 0;
                  }).reduce(function (t, e) {
                    return t + e;
                  }, 0)];
                }).sort(function (t, e) {
                  return t[1] - e[1];
                })[0]) ? void 0 : B[0].placement;
                _t3 && (_n2 = _t3);
                return _context4.abrupt("break", 45);

              case 44:
                _n2 = c;

              case 45:
                if (!(r !== _n2)) {
                  _context4.next = 47;
                  break;
                }

                return _context4.abrupt("return", {
                  reset: {
                    placement: _n2
                  }
                });

              case 47:
                return _context4.abrupt("return", {});

              case 48:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  };
};

function R(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}

function A(t) {
  return g.some(function (e) {
    return t[e] >= 0;
  });
}

var P = function P(t) {
  return void 0 === t && (t = {}), {
    name: "hide",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _t4, _t4$strategy, n, o, i, _t5, _t6;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _t4 = t, _t4$strategy = _t4.strategy, n = _t4$strategy === void 0 ? "referenceHidden" : _t4$strategy, o = _objectWithoutProperties(_t4, _excluded3), i = e.rects;
                _context5.t0 = n;
                _context5.next = _context5.t0 === "referenceHidden" ? 4 : _context5.t0 === "escaped" ? 11 : 18;
                break;

              case 4:
                _context5.t1 = R;
                _context5.next = 7;
                return s(e, _objectSpread(_objectSpread({}, o), {}, {
                  elementContext: "reference"
                }));

              case 7:
                _context5.t2 = _context5.sent;
                _context5.t3 = i.reference;
                _t5 = (0, _context5.t1)(_context5.t2, _context5.t3);
                return _context5.abrupt("return", {
                  data: {
                    referenceHiddenOffsets: _t5,
                    referenceHidden: A(_t5)
                  }
                });

              case 11:
                _context5.t4 = R;
                _context5.next = 14;
                return s(e, _objectSpread(_objectSpread({}, o), {}, {
                  altBoundary: !0
                }));

              case 14:
                _context5.t5 = _context5.sent;
                _context5.t6 = i.floating;
                _t6 = (0, _context5.t4)(_context5.t5, _context5.t6);
                return _context5.abrupt("return", {
                  data: {
                    escapedOffsets: _t6,
                    escaped: A(_t6)
                  }
                });

              case 18:
                return _context5.abrupt("return", {});

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  };
},
    T = function T(t) {
  return void 0 === t && (t = {}), {
    name: "inline",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var i, r, s, u, m, _t7, _t7$padding, g, d, p, h, y, x, w;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                i = e.placement;
                r = e.elements;
                s = e.rects;
                u = e.platform;
                m = e.strategy;
                _t7 = t;
                _t7$padding = _t7.padding;
                g = _t7$padding === void 0 ? 2 : _t7$padding;
                d = _t7.x;
                p = _t7.y;
                _context6.t0 = l;

                if (!u.convertOffsetParentRelativeRectToViewportRelativeRect) {
                  _context6.next = 24;
                  break;
                }

                _context6.t2 = u;
                _context6.t3 = s.reference;
                _context6.next = 16;
                return null == u.getOffsetParent ? void 0 : u.getOffsetParent(r.floating);

              case 16:
                _context6.t4 = _context6.sent;
                _context6.t5 = m;
                _context6.t6 = {
                  rect: _context6.t3,
                  offsetParent: _context6.t4,
                  strategy: _context6.t5
                };
                _context6.next = 21;
                return _context6.t2.convertOffsetParentRelativeRectToViewportRelativeRect.call(_context6.t2, _context6.t6);

              case 21:
                _context6.t1 = _context6.sent;
                _context6.next = 25;
                break;

              case 24:
                _context6.t1 = s.reference;

              case 25:
                _context6.t7 = _context6.t1;
                h = (0, _context6.t0)(_context6.t7);
                _context6.next = 29;
                return null == u.getClientRects ? void 0 : u.getClientRects(r.reference);

              case 29:
                _context6.t8 = _context6.sent;

                if (_context6.t8) {
                  _context6.next = 32;
                  break;
                }

                _context6.t8 = [];

              case 32:
                y = _context6.t8;
                x = a(g);
                _context6.next = 36;
                return u.getElementRects({
                  reference: {
                    getBoundingClientRect: function getBoundingClientRect() {
                      if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find(function (t) {
                        return d > t.left - x.left && d < t.right + x.right && p > t.top - x.top && p < t.bottom + x.bottom;
                      }) || h;

                      if (y.length >= 2) {
                        if ("x" === o(i)) {
                          var _t9 = y[0],
                              _e6 = y[y.length - 1],
                              _o = "top" === n(i),
                              _r2 = _t9.top,
                              _a3 = _e6.bottom,
                              _l2 = _o ? _t9.left : _e6.left,
                              _s3 = _o ? _t9.right : _e6.right;

                          return {
                            top: _r2,
                            bottom: _a3,
                            left: _l2,
                            right: _s3,
                            width: _s3 - _l2,
                            height: _a3 - _r2,
                            x: _l2,
                            y: _r2
                          };
                        }

                        var _t8 = "left" === n(i),
                            _e5 = f.apply(void 0, _toConsumableArray(y.map(function (t) {
                          return t.right;
                        }))),
                            _r = c.apply(void 0, _toConsumableArray(y.map(function (t) {
                          return t.left;
                        }))),
                            _a2 = y.filter(function (n) {
                          return _t8 ? n.left === _r : n.right === _e5;
                        }),
                            _l = _a2[0].top,
                            _s2 = _a2[_a2.length - 1].bottom;

                        return {
                          top: _l,
                          bottom: _s2,
                          left: _r,
                          right: _e5,
                          width: _e5 - _r,
                          height: _s2 - _l,
                          x: _r,
                          y: _l
                        };
                      }

                      return h;
                    }
                  },
                  floating: r.floating,
                  strategy: m
                });

              case 36:
                w = _context6.sent;
                return _context6.abrupt("return", s.reference.x !== w.reference.x || s.reference.y !== w.reference.y || s.reference.width !== w.reference.width || s.reference.height !== w.reference.height ? {
                  reset: {
                    rects: w
                  }
                } : {});

              case 38:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  };
};

var O = function O(e) {
  return void 0 === e && (e = 0), {
    name: "offset",
    options: e,
    fn: function fn(i) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var r, a, l;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                r = i.x;
                a = i.y;
                _context8.next = 4;
                return function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, i) {
                    var r, a, l, s, c, f, u, m, g, d, _ref5, p, h, y;

                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            r = e.placement;
                            a = e.platform;
                            l = e.elements;
                            _context7.next = 5;
                            return null == a.isRTL ? void 0 : a.isRTL(l.floating);

                          case 5:
                            s = _context7.sent;
                            c = n(r);
                            f = t(r);
                            u = "x" === o(r);
                            m = ["left", "top"].includes(c) ? -1 : 1;
                            g = s && u ? -1 : 1;
                            d = "function" == typeof i ? i(e) : i;
                            _ref5 = "number" == typeof d ? {
                              mainAxis: d,
                              crossAxis: 0,
                              alignmentAxis: null
                            } : _objectSpread({
                              mainAxis: 0,
                              crossAxis: 0,
                              alignmentAxis: null
                            }, d), p = _ref5.mainAxis, h = _ref5.crossAxis, y = _ref5.alignmentAxis;
                            return _context7.abrupt("return", (f && "number" == typeof y && (h = "end" === f ? -1 * y : y), u ? {
                              x: h * g,
                              y: p * m
                            } : {
                              x: p * m,
                              y: h * g
                            }));

                          case 14:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x7, _x8) {
                    return _ref4.apply(this, arguments);
                  };
                }()(i, e);

              case 4:
                l = _context8.sent;
                return _context8.abrupt("return", {
                  x: r + l.x,
                  y: a + l.y,
                  data: l
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  };
};

function D(t) {
  return "x" === t ? "y" : "x";
}

var E = function E(t) {
  return void 0 === t && (t = {}), {
    name: "shift",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _objectSpread3;

        var i, r, a, _t10, _t10$mainAxis, l, _t10$crossAxis, c, _t10$limiter, f, m, g, d, p, h, y, x, _t11, _t12, w;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                i = e.x;
                r = e.y;
                a = e.placement;
                _t10 = t;
                _t10$mainAxis = _t10.mainAxis;
                l = _t10$mainAxis === void 0 ? !0 : _t10$mainAxis;
                _t10$crossAxis = _t10.crossAxis;
                c = _t10$crossAxis === void 0 ? !1 : _t10$crossAxis;
                _t10$limiter = _t10.limiter;
                f = _t10$limiter === void 0 ? {
                  fn: function fn(t) {
                    var e = t.x,
                        n = t.y;
                    return {
                      x: e,
                      y: n
                    };
                  }
                } : _t10$limiter;
                m = _objectWithoutProperties(_t10, _excluded4);
                g = {
                  x: i,
                  y: r
                };
                _context9.next = 14;
                return s(e, m);

              case 14:
                d = _context9.sent;
                p = o(n(a));
                h = D(p);
                y = g[p], x = g[h];

                if (l) {
                  _t11 = "y" === p ? "bottom" : "right";
                  y = u(y + d["y" === p ? "top" : "left"], y, y - d[_t11]);
                }

                if (c) {
                  _t12 = "y" === h ? "bottom" : "right";
                  x = u(x + d["y" === h ? "top" : "left"], x, x - d[_t12]);
                }

                w = f.fn(_objectSpread(_objectSpread({}, e), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, p, y), _defineProperty(_objectSpread3, h, x), _objectSpread3)));
                return _context9.abrupt("return", _objectSpread(_objectSpread({}, w), {}, {
                  data: {
                    x: w.x - i,
                    y: w.y - r
                  }
                }));

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  };
},
    L = function L(t) {
  return void 0 === t && (t = {}), {
    options: t,
    fn: function fn(e) {
      var _ref6;

      var i = e.x,
          r = e.y,
          a = e.placement,
          l = e.rects,
          s = e.middlewareData,
          _t13 = t,
          _t13$offset = _t13.offset,
          c = _t13$offset === void 0 ? 0 : _t13$offset,
          _t13$mainAxis = _t13.mainAxis,
          f = _t13$mainAxis === void 0 ? !0 : _t13$mainAxis,
          _t13$crossAxis = _t13.crossAxis,
          u = _t13$crossAxis === void 0 ? !0 : _t13$crossAxis,
          m = {
        x: i,
        y: r
      },
          g = o(a),
          d = D(g);
      var p = m[g],
          h = m[d];
      var y = "function" == typeof c ? c(e) : c,
          x = "number" == typeof y ? {
        mainAxis: y,
        crossAxis: 0
      } : _objectSpread({
        mainAxis: 0,
        crossAxis: 0
      }, y);

      if (f) {
        var _t14 = "y" === g ? "height" : "width",
            _e7 = l.reference[g] - l.floating[_t14] + x.mainAxis,
            _n3 = l.reference[g] + l.reference[_t14] - x.mainAxis;

        p < _e7 ? p = _e7 : p > _n3 && (p = _n3);
      }

      if (u) {
        var w, v;

        var _t15 = "y" === g ? "width" : "height",
            _e8 = ["top", "left"].includes(n(a)),
            _o2 = l.reference[d] - l.floating[_t15] + (_e8 && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (_e8 ? 0 : x.crossAxis),
            _i3 = l.reference[d] + l.reference[_t15] + (_e8 ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (_e8 ? x.crossAxis : 0);

        h < _o2 ? h = _o2 : h > _i3 && (h = _i3);
      }

      return _ref6 = {}, _defineProperty(_ref6, g, p), _defineProperty(_ref6, d, h), _ref6;
    }
  };
},
    k = function k(e) {
  return void 0 === e && (e = {}), {
    name: "size",
    options: e,
    fn: function fn(o) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var i, r, a, l, _e9, _e9$apply, c, u, m, g, d, p, h, y, x, w, v, b, R;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                i = o.placement;
                r = o.rects;
                a = o.platform;
                l = o.elements;
                _e9 = e;
                _e9$apply = _e9.apply;
                c = _e9$apply === void 0 ? function () {} : _e9$apply;
                u = _objectWithoutProperties(_e9, _excluded5);
                _context10.next = 10;
                return s(o, u);

              case 10:
                m = _context10.sent;
                g = n(i);
                d = t(i);

                if (!("top" === g || "bottom" === g)) {
                  _context10.next = 32;
                  break;
                }

                p = g;
                _context10.t0 = d;
                _context10.next = 18;
                return null == a.isRTL ? void 0 : a.isRTL(l.floating);

              case 18:
                if (!_context10.sent) {
                  _context10.next = 22;
                  break;
                }

                _context10.t1 = "start";
                _context10.next = 23;
                break;

              case 22:
                _context10.t1 = "end";

              case 23:
                _context10.t2 = _context10.t1;

                if (!(_context10.t0 === _context10.t2)) {
                  _context10.next = 28;
                  break;
                }

                _context10.t3 = "left";
                _context10.next = 29;
                break;

              case 28:
                _context10.t3 = "right";

              case 29:
                h = _context10.t3;
                _context10.next = 33;
                break;

              case 32:
                h = g, p = "end" === d ? "top" : "bottom";

              case 33:
                y = f(m.left, 0), x = f(m.right, 0), w = f(m.top, 0), v = f(m.bottom, 0), b = {
                  availableHeight: r.floating.height - (["left", "right"].includes(i) ? 2 * (0 !== w || 0 !== v ? w + v : f(m.top, m.bottom)) : m[p]),
                  availableWidth: r.floating.width - (["top", "bottom"].includes(i) ? 2 * (0 !== y || 0 !== x ? y + x : f(m.left, m.right)) : m[h])
                };
                _context10.next = 36;
                return c(_objectSpread(_objectSpread({}, o), b));

              case 36:
                _context10.next = 38;
                return a.getDimensions(l.floating);

              case 38:
                R = _context10.sent;
                return _context10.abrupt("return", r.floating.width !== R.width || r.floating.height !== R.height ? {
                  reset: {
                    rects: !0
                  }
                } : {});

              case 40:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  };
};

export { m as arrow, v as autoPlacement, r as computePosition, s as detectOverflow, b as flip, P as hide, T as inline, L as limitShift, O as offset, l as rectToClientRect, E as shift, k as size };